module.exports = "<v-container> <v-layout row wrap> <v-flex xs6> <p>Podaj datę od:</p> <v-date-picker v-model=waterUsageStart type=month locale=pl v-bind:min=startData v-bind:max=waterUsageEnd v-on:input=\"updateValue('waterUsageStart', $event)\"></v-date-picker> </v-flex> <v-flex xs6> <p>Podaj datę do:</p> <v-date-picker v-model=waterUsageEnd type=month locale=pl v-bind:min=waterUsageStart v-bind:max=endData v-on:input=\"updateValue('waterUsageEnd', $event)\"></v-date-picker> </v-flex> </v-layout> </v-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/viewer/analysis/template/templateDialogWaterUsageInZones.html
// module id = 1453
// module chunks = 0